import About from '@/pages/about/About';

export default About;
